import {createReducer, on} from '@ngrx/store';

import {EActionStatus} from '@app/shared/enums/action-status.enum';
import {IStaticPageState} from '../model/static-pages-state.model';
import {
  contactAction,
  contactEffectError,
  contactEffectFailure,
  contactEffectSuccess,
  cookiePolicyAction,
  cookiePolicyEffectError,
  cookiePolicyEffectFailure,
  cookiePolicyEffectSuccess,
  howtoOrderPageAction,
  howtoOrderPageEffectError,
  howtoOrderPageEffectFailure,
  howtoOrderPageEffectSuccess,
  legalNoticeAction,
  legalNoticeEffectError,
  legalNoticeEffectFailure,
  legalNoticeEffectSuccess,
  privacyPolicyAction,
  privacyPolicyEffectError,
  privacyPolicyEffectFailure,
  privacyPolicyEffectSuccess,
  termsAndConditionsAction,
  termsAndConditionsEffectError,
  termsAndConditionsEffectFailure,
  termsAndConditionsEffectSuccess,
  welcomePageAction,
  welcomePageEffectError,
  welcomePageEffectFailure,
  welcomePageEffectSuccess,
} from './static-pages.actions';

const initialState: IStaticPageState = {
  termsAndConditionsStatus: EActionStatus.Initial,
  termsAndConditionsSuccessResponse: null,
  termsAndConditionsFailureReason: '',
  termsAndConditionsErrorMessage: '',
  legalNoticeStatus: EActionStatus.Initial,
  legalNoticeSuccessResponse: null,
  legalNoticeFailureReason: '',
  legalNoticeErrorMessage: '',
  privacyPolicyStatus: EActionStatus.Initial,
  privacyPolicySuccessResponse: null,
  privacyPolicyFailureReason: '',
  privacyPolicyErrorMessage: '',
  cookiePolicyStatus: EActionStatus.Initial,
  cookiePolicySuccessResponse: null,
  cookiePolicyFailureReason: '',
  cookiePolicyErrorMessage: '',
  contactStatus: EActionStatus.Initial,
  contactSuccessResponse: null,
  contactFailureReason: '',
  contactErrorMessage: '',
  welcomePageStatus: EActionStatus.Initial,
  welcomePageSuccessResponse: null,
  welcomePageFailureReason: '',
  welcomePageErrorMessage: '',
  howtoOrderPageStatus: EActionStatus.Initial,
  howtoOrderPageSuccessResponse: null,
  howtoOrderPageFailureReason: '',
  howtoOrderPageErrorMessage: '',
};

export const staticPageReducer = createReducer(
  initialState,
  on(termsAndConditionsAction, state => ({
    ...state,
    termsAndConditionsStatus: EActionStatus.Pending,
  })),
  on(termsAndConditionsEffectSuccess, (state, {response}) => ({
    ...state,
    termsAndConditionsStatus: EActionStatus.Success,
    termsAndConditionsSuccessResponse: response,
  })),
  on(termsAndConditionsEffectFailure, (state, {reason}) => ({
    ...state,
    termsAndConditionsStatus: EActionStatus.Failure,
    termsAndConditionsFailureReason: reason,
  })),
  on(termsAndConditionsEffectError, (state, {error}) => ({
    ...state,
    termsAndConditionsStatus: EActionStatus.Error,
    termsAndConditionsErrorMessage: error,
  })),
  on(legalNoticeAction, state => ({
    ...state,
    legalNoticeStatus: EActionStatus.Pending,
  })),
  on(legalNoticeEffectSuccess, (state, {response}) => ({
    ...state,
    legalNoticeStatus: EActionStatus.Success,
    legalNoticeSuccessResponse: response,
  })),
  on(legalNoticeEffectFailure, (state, {reason}) => ({
    ...state,
    legalNoticeStatus: EActionStatus.Failure,
    legalNoticeFailureReason: reason,
  })),
  on(legalNoticeEffectError, (state, {error}) => ({
    ...state,
    legalNoticeStatus: EActionStatus.Error,
    legalNoticeErrorMessage: error,
  })),
  on(privacyPolicyAction, state => ({
    ...state,
    privacyPolicyStatus: EActionStatus.Pending,
  })),
  on(privacyPolicyEffectSuccess, (state, {response}) => ({
    ...state,
    privacyPolicyStatus: EActionStatus.Success,
    privacyPolicySuccessResponse: response,
  })),
  on(privacyPolicyEffectFailure, (state, {reason}) => ({
    ...state,
    privacyPolicyStatus: EActionStatus.Failure,
    privacyPolicyFailureReason: reason,
  })),
  on(privacyPolicyEffectError, (state, {error}) => ({
    ...state,
    privacyPolicyStatus: EActionStatus.Error,
    privacyPolicyErrorMessage: error,
  })),
  on(cookiePolicyAction, state => ({
    ...state,
    cookiePolicyStatus: EActionStatus.Pending,
  })),
  on(cookiePolicyEffectSuccess, (state, {response}) => ({
    ...state,
    cookiePolicyStatus: EActionStatus.Success,
    cookiePolicySuccessResponse: response,
  })),
  on(cookiePolicyEffectFailure, (state, {reason}) => ({
    ...state,
    cookiePolicyStatus: EActionStatus.Failure,
    cookiePolicyFailureReason: reason,
  })),
  on(cookiePolicyEffectError, (state, {error}) => ({
    ...state,
    cookiePolicyStatus: EActionStatus.Error,
    cookiePolicyErrorMessage: error,
  })),
  on(contactAction, state => ({
    ...state,
    contactStatus: EActionStatus.Pending,
  })),
  on(contactEffectSuccess, (state, {response}) => ({
    ...state,
    contactStatus: EActionStatus.Success,
    contactSuccessResponse: response,
  })),
  on(contactEffectFailure, (state, {reason}) => ({
    ...state,
    contactStatus: EActionStatus.Failure,
    contactFailureReason: reason,
  })),
  on(contactEffectError, (state, {error}) => ({
    ...state,
    contactStatus: EActionStatus.Error,
    contactErrorMessage: error,
  })),
  on(welcomePageAction, state => ({
    ...state,
    welcomePageStatus: EActionStatus.Pending,
  })),
  on(welcomePageEffectSuccess, (state, {response}) => ({
    ...state,
    welcomePageStatus: EActionStatus.Success,
    welcomePageSuccessResponse: response,
  })),
  on(welcomePageEffectFailure, (state, {reason}) => ({
    ...state,
    welcomePageStatus: EActionStatus.Failure,
    welcomePageFailureReason: reason,
  })),
  on(welcomePageEffectError, (state, {error}) => ({
    ...state,
    welcomePageStatus: EActionStatus.Error,
    welcomePageErrorMessage: error,
  })),
  on(howtoOrderPageAction, state => ({
    ...state,
    howtoOrderPageStatus: EActionStatus.Pending,
  })),
  on(howtoOrderPageEffectSuccess, (state, {response}) => ({
    ...state,
    howtoOrderPageStatus: EActionStatus.Success,
    howtoOrderPageSuccessResponse: response,
  })),
  on(howtoOrderPageEffectFailure, (state, {reason}) => ({
    ...state,
    howtoOrderPageStatus: EActionStatus.Failure,
    howtoOrderPageFailureReason: reason,
  })),
  on(howtoOrderPageEffectError, (state, {error}) => ({
    ...state,
    howtoOrderPageStatus: EActionStatus.Error,
    howtoOrderPageErrorMessage: error,
  }))
);
